import request from "../utils/request-axios";
import api from "../utils/api";

//系统公司列表
export function getCompanyPage(params) {
  return request(`${api.getCompanyPage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}



// WEBPACK FOOTER //
// ./src/services/systemCompany.js